import axiosInstance from "../../utils/axiosConfig";
import React, { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { API_URL } from "../../constant";
import { useAuth } from "../../context/auth-context";
import DocumentLightbox from "../../components/DocumentLightbox";

const isLogKyc1 = (d: any) => d && d.kyc1;
const Profile = ({ customerDeet }: any) => {
  const { isAuthenticated } = useAuth();
  const [preview, setPreview] = useState<{ url: string; title: string } | null>(
    null
  );
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [emailConfirm, setEmailConfirm] = useState<boolean>();
  const [copyMail, setCopyMail] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>("");
  const [copyId, setCopyId] = useState<boolean>(false);
  const [copyNumber, setCopyNumber] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  const fromLog = isLogKyc1(customerDeet);
  const k1Data = customerDeet?.kyc1?.data ?? {};
  const smile = customerDeet?.kyc1?.smile_id_data;
  const logFirstName = smile?.firstName ?? k1Data?.firstName ?? "";
  const logLastName = smile?.lastName ?? k1Data?.lastName ?? "";
  const logFullName = smile?.fullName ?? k1Data?.fullName ?? "";
  const logPhone = smile?.phoneNumber ?? k1Data?.phoneNumber ?? "";
  const logBvn = k1Data?.bvn ?? smile?.idNumber ?? "";
  const userIdForCopy =
    customerDeet?.kyc2?.data?.userId ?? customerDeet?.userId?._id;

  // Fetch user by customer ID to get email, DeexTag, phone when not on log (or to fill gaps when from log)
  useEffect(() => {
    const userId = userIdForCopy ?? customerDeet?.userId?._id;
    if (!userId || !isAuthenticated) return;
    axiosInstance
      .get(`${API_URL}api/users/${userId}`)
      .then((r: any) => {
        const userData = r.data?.data?.user ?? {};
        setEmail(userData.email?.address || "");
        setEmailConfirm(userData.email?.isVerified ?? false);
        setUserName(userData.profile?.username || "");
        setPhoneNumber(userData.phone?.number || "");
        if (!fromLog && userData.profile) {
          setFirstName(userData.profile.firstName || "");
          setLastName(userData.profile.lastName || "");
        }
      })
      .catch((e: any) => {
        console.log(e.response?.data?.message);
      });
  }, [isAuthenticated, userIdForCopy, customerDeet?.userId?._id, fromLog]);
  const dispFirst = fromLog ? logFirstName : firstName;
  const dispLast = fromLog ? logLastName : lastName;
  const dispPhone = fromLog ? logPhone : phoneNumber;
  const initials =
    (dispFirst?.charAt(0) ?? "") + (dispLast?.charAt(0) ?? "") || "—";

  const copyTimeout = 3000;
  const onCopy = (setter: (v: boolean) => void) => {
    setter(true);
    setTimeout(() => setter(false), copyTimeout);
  };

  const has = (v: any) => v != null && String(v).trim() !== "";

  const profileRows = (
    <>
      {has(email) && (
        <>
          <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
            <span className="text-[#869AA9] text-[12px] font-medium">
              Email
            </span>
            <CopyToClipboard text={email} onCopy={() => onCopy(setCopyMail)}>
              {copyMail ? (
                <span className="text-[11px] text-[#03C668]">Copied</span>
              ) : (
                <span className="text-[#0C84DA] text-[12px] font-medium cursor-pointer hover:underline truncate max-w-[200px] text-right">
                  {email}
                </span>
              )}
            </CopyToClipboard>
          </div>
          <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
            <span className="text-[#869AA9] text-[12px] font-medium">
              Email verification
            </span>
            <span
              className={
                emailConfirm
                  ? "text-[#03C668] text-[12px] font-medium"
                  : "text-[#F28A0F] text-[12px] font-medium"
              }
            >
              {emailConfirm ? "Confirmed" : "Pending"}
            </span>
          </div>
        </>
      )}
      {has(dispFirst) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">
            First name
          </span>
          <span className="text-white text-[12px] font-medium">
            {dispFirst}
          </span>
        </div>
      )}
      {has(dispLast) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">
            Last name
          </span>
          <span className="text-white text-[12px] font-medium">{dispLast}</span>
        </div>
      )}
      {has(logFullName || smile?.fullName) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">
            Full name
          </span>
          <span className="text-white text-[12px] font-medium">
            {logFullName || smile?.fullName}
          </span>
        </div>
      )}
      {has(logBvn || smile?.idNumber) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">
            BVN / ID number
          </span>
          <span className="text-[#0C84DA] text-[12px] font-medium">
            {logBvn || smile?.idNumber}
          </span>
        </div>
      )}
      {has(userName) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">
            DeexTag
          </span>
          <span className="text-white text-[12px] font-medium">
            @{userName}
          </span>
        </div>
      )}
      {has(smile?.dob) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">
            Birthday
          </span>
          <span className="text-white text-[12px] font-medium">
            {smile?.dob}
          </span>
        </div>
      )}
      {has(dispPhone || phoneNumber) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">Phone</span>
          <CopyToClipboard
            text={dispPhone || phoneNumber}
            onCopy={() => onCopy(setCopyNumber)}
          >
            {copyNumber ? (
              <span className="text-[11px] text-[#03C668]">Copied</span>
            ) : (
              <span className="text-[#0C84DA] text-[12px] font-medium cursor-pointer hover:underline">
                {dispPhone || phoneNumber}
              </span>
            )}
          </CopyToClipboard>
        </div>
      )}
      {has(userIdForCopy) && (
        <div className="flex justify-between items-center py-2.5 border-b border-[#1C2227]/60">
          <span className="text-[#869AA9] text-[12px] font-medium">
            Customer ID
          </span>
          <CopyToClipboard
            text={userIdForCopy}
            onCopy={() => onCopy(setCopyId)}
          >
            {copyId ? (
              <span className="text-[11px] text-[#03C668]">Copied</span>
            ) : (
              <span className="text-[#0C84DA] text-[12px] font-medium cursor-pointer hover:underline truncate max-w-[180px] text-right">
                {userIdForCopy}
              </span>
            )}
          </CopyToClipboard>
        </div>
      )}
    </>
  );

  return (
    <div className="w-full bg-[#0D0D0D] p-4 sm:p-6 md:p-8">
      <h4 className="text-white font-sora font-bold text-[14px] sm:text-[16px]">
        Profile Completion
      </h4>
      <div className="w-full mt-4 sm:mt-6 md:mt-8">
        <div
          className={`flex flex-col ${
            smile ? "lg:flex-row" : ""
          } gap-6 lg:gap-8 items-stretch`}
        >
          <div className={smile ? "flex-1 min-w-0" : "w-full"}>
            <div className="rounded-xl border border-[#1C2227] bg-[#141414] p-5 sm:p-6">
              <div className="flex items-center gap-4 mb-6 pb-4 border-b border-[#1C2227]">
                {smile?.imageUrl ? (
                  <img
                    src={smile.imageUrl}
                    alt="Verification"
                    className="w-14 h-14 rounded-xl object-cover border-2 border-[#1C2227] flex-shrink-0"
                  />
                ) : (
                  <div className="w-14 h-14 rounded-xl bg-[#032843] text-[#0C84DA] flex items-center justify-center font-bold font-sora text-[20px] flex-shrink-0">
                    {initials}
                  </div>
                )}
                <div>
                  <h4 className="text-white font-sora font-bold text-[15px]">
                    Profile
                  </h4>
                  <p className="text-[#869AA9] text-[12px]">
                    {dispFirst || dispLast
                      ? `${dispFirst} ${dispLast}`.trim()
                      : "Personal & account details"}
                  </p>
                </div>
              </div>
              <div
                className={`grid grid-cols-1 ${
                  smile ? "lg:grid-cols-1" : "lg:grid-cols-2"
                } gap-x-8 gap-y-0`}
              >
                {profileRows}
              </div>
            </div>
          </div>
          {smile && (
            <div className="w-full lg:w-[380px] lg:flex-shrink-0 mt-8 lg:mt-0">
              <div className="rounded-xl border border-[#1C2227] bg-[#141414] p-5 sm:p-6">
                <div className="flex items-center gap-3 mb-5 pb-4 border-b border-[#1C2227]">
                  <div className="w-10 h-10 rounded-lg bg-[#0C84DA]/10 flex items-center justify-center">
                    <svg
                      className="w-5 h-5 text-[#0C84DA]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-sora font-bold text-[14px]">
                      Smile ID Verification
                    </h4>
                    <p className="text-[#869AA9] text-[11px]">
                      Identity verification data
                    </p>
                  </div>
                </div>
                {smile.imageUrl && (
                  <div className="flex justify-center mb-5">
                    <button
                      type="button"
                      onClick={() =>
                        setPreview({
                          url: smile.imageUrl,
                          title: "Verification photo",
                        })
                      }
                      className="rounded-xl border-2 border-[#1C2227] shadow-lg overflow-hidden cursor-zoom-in hover:border-[#0C84DA]/50 transition-colors"
                    >
                      <img
                        src={smile.imageUrl}
                        alt="Verification"
                        className="w-[120px] h-[120px] object-cover"
                      />
                    </button>
                  </div>
                )}
                <div className="space-y-3">
                  {smile.address && (
                    <div className="flex flex-col gap-1">
                      <span className="text-[#617889] text-[11px] font-medium uppercase tracking-wide">
                        Address
                      </span>
                      <p className="text-[#DEE1E6] text-[13px] leading-snug">
                        {smile.address}
                      </p>
                    </div>
                  )}
                  {(smile.idType || smile.idNumber) && (
                    <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                      <span className="text-[#869AA9] text-[12px]">
                        ID type / number
                      </span>
                      <span className="text-[#0C84DA] font-semibold text-[12px]">
                        {[smile.idType, smile.idNumber]
                          .filter(Boolean)
                          .join(" · ") || "—"}
                      </span>
                    </div>
                  )}
                  {smile.gender && (
                    <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                      <span className="text-[#869AA9] text-[12px]">Gender</span>
                      <span className="text-white text-[12px] font-medium">
                        {smile.gender}
                      </span>
                    </div>
                  )}
                  {smile.nationality && (
                    <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                      <span className="text-[#869AA9] text-[12px]">
                        Nationality
                      </span>
                      <span className="text-white text-[12px] font-medium">
                        {smile.nationality}
                      </span>
                    </div>
                  )}
                  {smile.dob && (
                    <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                      <span className="text-[#869AA9] text-[12px]">
                        Date of birth
                      </span>
                      <span className="text-white text-[12px] font-medium">
                        {smile.dob}
                      </span>
                    </div>
                  )}
                  {smile.kycReceipt && (
                    <div className="pt-3">
                      <button
                        type="button"
                        onClick={() =>
                          setPreview({
                            url: smile.kycReceipt,
                            title: "KYC receipt",
                          })
                        }
                        className="inline-flex items-center gap-2 text-[#0C84DA] text-[13px] font-medium hover:underline"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                        View KYC receipt
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {preview && (
        <DocumentLightbox
          urls={[preview.url]}
          title={preview.title}
          onClose={() => setPreview(null)}
        />
      )}
    </div>
  );
};

export default Profile;
